import api from './api';

const getFormInquiry = (slug: number | string) => {
  return api.get(`parameter/v1/inquiry/${slug}`);
};

export default {
  getFormInquiry,
};
